import UserRepository from "./admin/UserRepository.js";
import RoomRepository from "./admin/RoomRepository.js";
import MaterialTypeRepository from "./admin/MaterialTypeRepository.js";
import MaterialRepository from "./admin/MaterialRepository.js";
import ProductRepository from "./admin/ProductRepository.js";
import ImageRepository from "./admin/ImageRepository.js";
import SocialRepository from "./admin/SocialRepository.js";
import HrmRepository from "./admin/HrmRepository.js";
import CustomerRepository from "./admin/CustomerRepository.js";
import OrderRepository from "./admin/OrderRepository.js";
import InformationRepository from "./admin/InformationRepository.js";
import ContactRepository from "./admin/ContactRepository.js";
import GalleryAdminRepository from "./admin/GalleryRepository.js"

import MaterialCustomerRepository from "./customer/MaterialRepository.js";
import ProductCustomerRepository from "./customer/ProductRepository.js";
import RoomCustomerRepository from "./customer/RoomRepository.js";
import HomeCustomerRepository from "./customer/HomeRepository.js";
import PaymentCustomerRepository from "./customer/PaymentRepository.js";
import GalleryRepository from "./customer/GalleryRepository.js";
import CustomerAuthRepository from "./customer/CustomerRepository.js";
import ContactCustomer from "./customer/ContactRepository.js";

const repositories = {

    //admin
    userAdmin: UserRepository,
    roomAdmin: RoomRepository,
    materialTypeAdmin: MaterialTypeRepository,
    materialAdmin: MaterialRepository,
    socialAdmin: SocialRepository,
    productAdmin: ProductRepository,
    imageAdmin: ImageRepository,
    hrmAdmin: HrmRepository,
    customerAdmin: CustomerRepository,
    orderAdmin: OrderRepository,
    informationAdmin: InformationRepository,
    contactAdmin: ContactRepository,
    galleryAdmin: GalleryAdminRepository,

    //customer
    materialCustomer: MaterialCustomerRepository,
    productCustomer: ProductCustomerRepository,
    roomCustomer: RoomCustomerRepository,
    homeCustomer: HomeCustomerRepository,
    paymentCustomer: PaymentCustomerRepository,
    galleryCustomer: GalleryRepository,
    customerAuth: CustomerAuthRepository,
    contactCustomer: ContactCustomer,
};

export const RepositoryFactory = {
    get: name => repositories[name],
};
